import React from 'react';
import PageBanner from '../layout/PageBanner';
import Button from '../ui/Button';
import RecipeHero from '../recipes/RecipeHero';
import IngredientsCard from '../recipes/IngredientsCard';
import RecipeIntro from '../recipes/RecipeIntro';
import RecipeDirections from '../recipes/RecipeDirections';
import RecipeVariations from '../recipes/RecipeVariations';
import BetaLink from '../../beta/BetaLink';

const RecipeDetailPage = ({ recipe }) => {
  if (!recipe) {
    return (
      <div>
        <PageBanner
          title="Recipe"
          breadcrumbs={[{ label: 'MIRAGE RECIPES', href: '/mirage-recipe' }]}
        />
        <section className="py-16 px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-serif font-bold mb-4">Recipe Not Found</h2>
            <p className="text-gray-600 mb-6">
              The recipe you're looking for isn't available yet.
            </p>
            <Button href="/mirage-recipe" variant="filled">
              Back to Recipes
            </Button>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div>
      <PageBanner
        title={recipe.title}
        breadcrumbs={[
          { label: 'MIRAGE RECIPES', href: '/mirage-recipe' },
          { label: recipe.title }
        ]}
      />

      <RecipeHero
        heroImage={recipe.heroImage}
        heroAlt={recipe.title}
        servings={recipe.servings}
        facts={recipe.facts}
      />

      <IngredientsCard
        ingredients={recipe.ingredients}
        sideImage={recipe.sideImage}
        sideAlt={`${recipe.title} detail`}
      />

      <RecipeIntro text={recipe.intro} />

      <RecipeDirections
        title={recipe.directions?.title}
        steps={recipe.directions?.steps || []}
      />

      <RecipeVariations blocks={recipe.variations || []} />

      <section className="py-10 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <BetaLink
            to="/mirage-recipe"
            className="inline-flex items-center gap-2 px-5 py-3 border border-primary-red text-primary-red rounded font-medium hover:bg-primary-red hover:text-white transition-colors"
          >
            Back to Recipes
          </BetaLink>
        </div>
      </section>
    </div>
  );
};

export default RecipeDetailPage;
